export default __webpack_public_path__ + "static/media/assessment_glide_1_2.f7786190.svg";